import { useContext, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import StaffAsExhibitor from "../../Components/StaffViews/StaffAsExhibitor"
import StaffAsOrganizer from "../../Components/StaffViews/StaffAsOrganizer"
import UserContext from "../../Context/UserContext"

export default function StaffPage(){
  const {role} = useParams()
  const {user} = useContext(UserContext)
  const navigate = useNavigate()
  useEffect(()=>{
    if(role!=='organizer' && role!=='exhibitor'){
      navigate(`/${user.role}`)
    }
  },[role, navigate, user])
  return<div className="container mx-auto px-4">
    {role==='organizer'?
    <StaffAsOrganizer/>:<></>}
    {role==='exhibitor'?
    <StaffAsExhibitor/>:<></>}
  </div>
}